import React, { useState } from 'react';
import { Save, Bell, DollarSign } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
interface Settings {
  companyName: string;
  email: string;
  phone: string;
  address: string;
  currency: string;
  taxRate: string;
  enableNotifications: boolean;
  enableEmailAlerts: boolean;
  autoAcceptOrders: boolean;
  requireOrderConfirmation: boolean;
}
export function SettingsGeneral() {
  const [settings, setSettings] = useState<Settings>(() => {
    const saved = localStorage.getItem('criket_general_settings');
    return saved ? JSON.parse(saved) : {
      companyName: 'Criket',
      email: 'admin@criket.com',
      phone: '809-555-1234',
      address: 'Santo Domingo, República Dominicana',
      currency: 'RD$',
      taxRate: '18',
      enableNotifications: true,
      enableEmailAlerts: true,
      autoAcceptOrders: false,
      requireOrderConfirmation: true
    };
  });
  const handleSave = () => {
    localStorage.setItem('criket_general_settings', JSON.stringify(settings));
    alert('✅ Configuración guardada exitosamente');
  };
  return <div className="space-y-6" data-id="element-2507">
      {/* Company Information */}
      <Card data-id="element-2508">
        <div className="flex items-center gap-3 mb-6" data-id="element-2509">
          <div className="p-2 bg-gray-100 dark:bg-gray-800 rounded-lg" data-id="element-2510">
            <DollarSign className="w-5 h-5 text-gray-700 dark:text-gray-300" data-id="element-2511" />
          </div>
          <div data-id="element-2512">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-2513">
              Información de la Empresa
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2514">
              Datos generales de tu negocio
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2515">
          <div data-id="element-2516">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2517">
              Nombre de la Empresa
            </label>
            <input type="text" value={settings.companyName} onChange={e => setSettings({
            ...settings,
            companyName: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-1 focus:ring-black focus:border-black dark:focus:ring-white dark:focus:border-white bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-id="element-2518" />
          </div>
          <div data-id="element-2519">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2520">
              Correo Electrónico
            </label>
            <input type="email" value={settings.email} onChange={e => setSettings({
            ...settings,
            email: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-1 focus:ring-black focus:border-black dark:focus:ring-white dark:focus:border-white bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-id="element-2521" />
          </div>
          <div data-id="element-2522">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2523">
              Teléfono
            </label>
            <input type="tel" value={settings.phone} onChange={e => setSettings({
            ...settings,
            phone: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-1 focus:ring-black focus:border-black dark:focus:ring-white dark:focus:border-white bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-id="element-2524" />
          </div>
          <div data-id="element-2525">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2526">
              Dirección
            </label>
            <input type="text" value={settings.address} onChange={e => setSettings({
            ...settings,
            address: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-1 focus:ring-black focus:border-black dark:focus:ring-white dark:focus:border-white bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-id="element-2527" />
          </div>
        </div>
      </Card>

      {/* Financial Settings */}
      <Card data-id="element-2528">
        <div className="flex items-center gap-3 mb-6" data-id="element-2529">
          <div className="p-2 bg-gray-100 dark:bg-gray-800 rounded-lg" data-id="element-2530">
            <DollarSign className="w-5 h-5 text-gray-700 dark:text-gray-300" data-id="element-2531" />
          </div>
          <div data-id="element-2532">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-2533">
              Configuración Financiera
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2534">
              Moneda e impuestos
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2535">
          <div data-id="element-2536">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2537">
              Moneda
            </label>
            <select value={settings.currency} onChange={e => setSettings({
            ...settings,
            currency: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-1 focus:ring-black focus:border-black dark:focus:ring-white dark:focus:border-white bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-id="element-2538">
              <option value="RD$" data-id="element-2539">Peso Dominicano (RD$)</option>
              <option value="USD" data-id="element-2540">Dólar Americano (USD)</option>
            </select>
          </div>
          <div data-id="element-2541">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-2542">
              Tasa de ITBIS (%)
            </label>
            <input type="number" value={settings.taxRate} onChange={e => setSettings({
            ...settings,
            taxRate: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-1 focus:ring-black focus:border-black dark:focus:ring-white dark:focus:border-white bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-id="element-2543" />
          </div>
        </div>
      </Card>

      {/* Notifications */}
      <Card data-id="element-2544">
        <div className="flex items-center gap-3 mb-6" data-id="element-2545">
          <div className="p-2 bg-gray-100 dark:bg-gray-800 rounded-lg" data-id="element-2546">
            <Bell className="w-5 h-5 text-gray-700 dark:text-gray-300" data-id="element-2547" />
          </div>
          <div data-id="element-2548">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-2549">
              Notificaciones
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2550">
              Configura alertas y notificaciones
            </p>
          </div>
        </div>

        <div className="space-y-4" data-id="element-2551">
          <label className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors" data-id="element-2552">
            <div data-id="element-2553">
              <p className="font-medium text-gray-900 dark:text-white" data-id="element-2554">
                Notificaciones Push
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2555">
                Recibe alertas en tiempo real
              </p>
            </div>
            <input type="checkbox" checked={settings.enableNotifications} onChange={e => setSettings({
            ...settings,
            enableNotifications: e.target.checked
          })} className="w-5 h-5 rounded border-gray-300 text-black focus:ring-black dark:border-gray-600 dark:bg-gray-700" data-id="element-2556" />
          </label>

          <label className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors" data-id="element-2557">
            <div data-id="element-2558">
              <p className="font-medium text-gray-900 dark:text-white" data-id="element-2559">
                Alertas por Email
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2560">
                Recibe resúmenes diarios por correo
              </p>
            </div>
            <input type="checkbox" checked={settings.enableEmailAlerts} onChange={e => setSettings({
            ...settings,
            enableEmailAlerts: e.target.checked
          })} className="w-5 h-5 rounded border-gray-300 text-black focus:ring-black dark:border-gray-600 dark:bg-gray-700" data-id="element-2561" />
          </label>

          <label className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors" data-id="element-2562">
            <div data-id="element-2563">
              <p className="font-medium text-gray-900 dark:text-white" data-id="element-2564">
                Auto-aceptar Pedidos
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2565">
                Acepta pedidos automáticamente sin confirmación
              </p>
            </div>
            <input type="checkbox" checked={settings.autoAcceptOrders} onChange={e => setSettings({
            ...settings,
            autoAcceptOrders: e.target.checked
          })} className="w-5 h-5 rounded border-gray-300 text-black focus:ring-black dark:border-gray-600 dark:bg-gray-700" data-id="element-2566" />
          </label>

          <label className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors" data-id="element-2567">
            <div data-id="element-2568">
              <p className="font-medium text-gray-900 dark:text-white" data-id="element-2569">
                Requerir Confirmación
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2570">
                Los empleados deben confirmar sus pedidos
              </p>
            </div>
            <input type="checkbox" checked={settings.requireOrderConfirmation} onChange={e => setSettings({
            ...settings,
            requireOrderConfirmation: e.target.checked
          })} className="w-5 h-5 rounded border-gray-300 text-black focus:ring-black dark:border-gray-600 dark:bg-gray-700" data-id="element-2571" />
          </label>
        </div>
      </Card>

      {/* Save Button */}
      <div className="flex justify-end" data-id="element-2572">
        <Button onClick={handleSave} leftIcon={<Save size={18} data-id="element-2574" />} size="lg" data-id="element-2573">
          Guardar Configuración
        </Button>
      </div>
    </div>;
}